import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/theme-chalk/el-icon.css';

const app = createApp(App);

app.use(store)
    .use(router)
    .use(ElementPlus, {locale: zhCn,})
    .mount('#app')
